<template>
  <div style="width: 100%">
    <router-view v-if="isLaunched" />
    <Launcher v-else />
    <UpdateDialog :open="updateDialog" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const UpdateDialog = () => import("./lib/UpdateDialog.vue");
const Launcher = () => import("./lib/Launcher.vue");

export default {
  name: "App",
  components: { UpdateDialog, Launcher },
  data() {
    return { updateDialog: false };
  },
  computed: {
    ...mapGetters(["isLaunched"]),
  },
  methods: {
    showUpdateDialog() {
      this.updateDialog = true;
    },
  },
  mounted() {
    document.addEventListener("swUpdated", this.showUpdateDialog, {
      once: true,
      passive: true,
    });
  },
};
</script>
